import hljs from 'highlight.js/lib/core'
import ruby from 'highlight.js/lib/languages/ruby'
import python from 'highlight.js/lib/languages/python'
import javascript from 'highlight.js/lib/languages/javascript'
import bash from 'highlight.js/lib/languages/bash'
import http from 'highlight.js/lib/languages/http'
import json from 'highlight.js/lib/languages/json'

hljs.registerLanguage('ruby', ruby)
hljs.registerLanguage('python', python)
hljs.registerLanguage('javascript', javascript)
hljs.registerLanguage('bash', bash)
hljs.registerLanguage('http', http)
hljs.registerLanguage('json', json)

/**
 * Apply highlight.js to all <pre><code class="language-…"> blocks
 * within an optional scope (defaults to the whole document).
 *
 * Idempotent — already-highlighted blocks (with the `hljs` class)
 * are skipped, so this is safe to call multiple times.
 */
export function highlightAll(scope: ParentNode = document): void {
  scope.querySelectorAll('pre code').forEach((el) => {
    const element = el as HTMLElement
    if (element.dataset.highlighted === 'yes') return
    hljs.highlightElement(element)
    element.dataset.highlighted = 'yes'
  })
}
